<template>
  <div>
    <div class="row">
      <h1>Grupo de Descontos Varejo</h1>
    </div>
    <div class="row mt-3">
      <b-button variant="primary" size="sm" class="mr-2" @click="voltar">
        <i class="fas fa-arrow-left"></i> Voltar</b-button>
      <b-button v-if="perfil === 'adm'" variant="success" size="sm" class="mr-2" @click="adicionarGrupo"><i class="fa fa-plus"></i> Adicionar</b-button>
    </div>
    <b-row class="mt-3">
      <b-container fluid >
        <b-table
          hover 
          :items="faixas"
          :busy="isLoading"
          :fields="header"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          empty-text="Nenhuma faixa de desconto encontrada ..."
          stacked="md"
          show-empty
          small
          striped
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Carregando ...</strong>
            </div>
          </template>
          <!-- COLUNA EDITAR -->
          <template #cell(id)="row">
              <b-button size="sm" variant="primary" @click="editar(row.item)">
                  <i class="fa fa-edit"></i>
              </b-button>
          </template>
        </b-table>
      </b-container>
    </b-row>

    <!-- Modal Desconto -->
    <b-modal v-model="modalDesconto" size="xl">
        <b-overlay :show="show" rounded="sm">
          <b-card>
            <b-row align-v="end" class="mb-3" v-if="novaFaixa == true">
              <b-col class="col-md-2">
                <label for="grupoDesc">Grupo de Desconto</label>
              </b-col>
              <b-col class="col-md-2">
                <b-form-input v-mask="'SS'" autofocus size="sm" id="grupoDesc" placeholder="Z" v-model="grupoDesconto"></b-form-input>
              </b-col>
            </b-row>
              <b-row class="mb-3 ml-3">
                <b-button :disabled="perfil !== 'adm'" variant="primary" title="Adicionar" size="sm" class="text-left" @click="addDesconto"> <i class="fa fa-plus"></i>Adicionar</b-button>
              </b-row>
              <b-row align-v="end" class="mb-3" v-for="(desconto, index) in descontos" :key="index">
                <b-col>
                  <label for="min ">Mínimo(R$)</label>
                  <b-form-input placeholder="R$" :disabled="perfil !== 'adm'" id="min" size="sm" v-mask="['#,##','##,##', '###,##','####,##','#####,##','######,##','#######,##','########,##','#########,##' ,'##########,##']" v-model="desconto.quantidade_minima"></b-form-input>
                </b-col>
                <b-col>
                  <label for="max ">Máximo(R$)</label>
                  <b-form-input  placeholder="R$" :disabled="perfil !== 'adm'" id="max" size="sm" v-mask="['#,##','##,##', '###,##','####,##','#####,##','######,##','#######,##','########,##','#########,##' ,'##########,##']"  v-model="desconto.quantidade_maxima"></b-form-input>
                </b-col>
                <b-col>
                  <label for="val">Desconto(%)</label>
                  <b-form-input  placeholder="%" :disabled="perfil !== 'adm'" id="val" size="sm" v-mask="['#,##','##,##']" v-model="desconto.valor" ></b-form-input>
                </b-col>
                <b-col class="col-md-1">
                  <b-button :disabled="perfil !== 'adm'" variant="danger" size="sm" title="Remover" @click="removeDesconto(desconto, index)"><i class="fa fa-trash-alt"></i></b-button>
                </b-col>
              </b-row>
          </b-card>
      </b-overlay>
        <template #modal-title>
          Grupo de Desconto {{descontos.length > 0 && descontos[0].grupo_desconto ? "- " + descontos[0].grupo_desconto : null}}
        </template>
      <template #modal-footer>
        <b-button
          size="sm"
          variant="primary"
          @click="saveDesconto()"
          :disabled="loading || perfil !== 'adm'"
        >
          <span v-if="loading">
            <b-spinner small type="grow"></b-spinner>
          </span>
          Salvar
        </b-button>
        <b-button size="sm" variant="danger" @click="modalDesconto = false"> Cancelar </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { VMoney } from "v-money";
export default {
  name: "descontos-venda-direta",
  directives: {
    money: VMoney,
  },
  data() {
    return {  
        faixas: [],
        excluir: [],
        perfil: null,
        show: false,
        grupoDesconto: '',
        novaFaixa: false,
        money: {
            decimal: ".",
            thousands: "",
            prefix: "",
            suffix: "",
            precision: 2,
            masked: false,
        },
        optionsDesconto: [
            {
            value: "PERCENTUAL",
            text: "% Percentual",

            },
            {
            value: "FIXO",
            text: "R$ Valor",
            },
        ],
      totalRows: 1,     
      sortBy: "grupo_desconto",
      sortDesc: false,
      sortDirection: "asc",
      isLoading: false,
      descontos: [],
      modalDesconto: false,
      loading: false,
      headerModal: [
        /*{
            key: "editar",
            label: ""
        }, */
        {
            key: "quantidade_minima",
            label: "Quantidade Mínima"
        },
        {
            key: "quantidade_maxima",
            label: "Quantidade Máxima"
        },
        {
            key: "tipo_desconto",
            label: "Tipo de Desconto"
        },
        {
            key: "valor",
            label: "Desconto"
        },
        {
            key: "updated_at",
            label: "Última Alteração"
        }
      ],
      header: [           
        {
          key: "grupo_desconto",
          label: "Grupo",
          sortable: true,
        },
        {
          key: "tipo_desconto",
          label: "Tipo de Desconto",
        },         
        {
            key:"id",
            class: 'text-left',
            label:""
        },     
      ],
      desconto: {
        id: null,
        quantidade_minima: 0,
        quantidade_maxima: 0,
        tipo_desconto: "PERCENTUAL",
        valor: 0,
        data_encerramento: "",
      },
    };
  },
  methods: {
    adicionarGrupo() {
      this.descontos = [];
      this.novaFaixa = true;
      this.grupoDesconto = '';
      this.modalDesconto = true;
      this.excluir = [];
    },
    addDesconto() {
            this.descontos.push({
                quantidade_minima: "",
                quantidade_maxima: "",
                valor: 0
            });
      },
    removeDesconto(d,i) {
        this.excluir.push(d);
        this.descontos.splice(i, 1);
    },
    voltar() {
      window.location.href = "/venda-direta/";
    },    
    editar(obj) {
        const vm = this;
        vm.excluir = [];
        vm.novaFaixa = false;
        let data = {
          grupo : obj.grupo_desconto
        }
        axios
            .post("/venda-direta/descontos/faixas", data)
            .then((response) => {
              //console.log(response);
              if(response) {
                  vm.grupoDesconto = obj.grupo_desconto;
                  vm.descontos = response.data;
                  vm.descontos.forEach(el => {
                    el.valor = el.valor.replace('.',',');
                    el.quantidade_minima =el.quantidade_minima;
                    el.quantidade_maxima = el.quantidade_maxima;
                  });
                  vm.modalDesconto = true;
              }
            })
            .catch((erro) => {
                console.log(erro);
                alert('Erro ao carregar a faixas de desconto!');
            })
    },
    getList() {
      const vm = this;      
      vm.isLoading = true;
      axios
        .get("/venda-direta/descontos/listarGrupos")
        .then((response) => {
          //console.log(response.data);         
          vm.faixas = response.data;
          vm.totalRows = response.data.length;
          vm.isLoading = false;
        })
        .catch((error) => {
          vm.isLoading = false;
          console.log("error", error);
        });
    },
    async saveDesconto() {
      const vm = this;
      let qtd = null;
      let erro = true;
      vm.descontos.forEach(el => {
        erro = true;
        let valor = parseFloat(el.valor.replace(',','.')).toFixed(2);
        let minimo = parseFloat((el.quantidade_minima.replace(',','.')));
        let maximo = parseFloat((el.quantidade_maxima.replace(',','.')));
        if(qtd && qtd >= minimo){           
          return vm.$swal(
            "A Quantidade mínima deve ser maior que a máxima anterior.",
            "",
            "error"
          );
        }
        if (minimo >= maximo) {          
          return vm.$swal(
            "A Quantidade mínima não pode ser maior que a máxima.",
            "",
            "error"
          );
        }
        if (minimo == "") {          
          return vm.$swal(
            "A Quantidade mínima precisa ser preenchida",
            "",
            "error"
          );
        }
        if (maximo === "") {          
          return vm.$swal(
            "A Quantidade máxima precisa ser preenchida",
            "",
            "error"
          );
        }
        if (valor === 0 || valor === '') {
          return vm.$swal("O Desconto não foi informado.", "", "error");
        }
        qtd = maximo;
        erro = false;   
      });
      if(erro){
        return;
      }

      let data = {
        descontos : vm.descontos,
        novaFaixa : vm.novaFaixa,
        grupoDesconto : vm.grupoDesconto,
        excluir : vm.excluir
      }

      vm.loading = true;
      await axios
        .post("/venda-direta/descontos", data)
        .then((response) => {
          if(response){
            //console.log(response);
            vm.modalDesconto = false;
            vm.loading = false;
            vm.getList();
          }
        })
        .catch((error) => {
          let _err = error.response.data;
          console.log(_err);
          vm.loading = false;
          vm.$swal.fire({
            type: "error",
            title: _err.msg
              ? _err.msg
              : "Erro desconhecido ao salvar Descontos varejo.",
          });
        });
    },
    getPerfil(){
      const vm = this;
      axios
      .get("/my-profile")
      .then((response) => {
        vm.perfil = response.data.profile.roles[0].name;
        console.log(vm.perfil);
      })
      .catch((erro) => {
        console.log(erro);
        alert(erro);
      })
    }
  },
  computed: {
    showDescontos() {
      return this.descontos;
    },
  },
  mounted() {
    this.getPerfil();
    this.getList();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/varejo/produtos/descontos.vue